// import external dependencies
import 'jquery';
//index.js file:

// Import everything from autoload
import './autoload/_bootstrap.js'

// import local dependencies
import Router from './util/Router';
import common from './routes/common.js';
import home from './routes/home.js';
import about from './routes/about.js';
import singleReferents from './routes/single-referents.js';
import anime from 'animejs/lib/anime.es';

const content = document.querySelector('.content')

window.contentIn = false;

var contentIn = anime({
  autoplay: false,
  easing: 'easeInOutSine',
  duration: 600,
  targets: content,
  opacity: 1,
  translateY: [-20, 0],
  complete: function(anim) {
    window.contentIn = true
  },
})

window.onpageshow = function() {
  contentIn.play()
}

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About page
  about,
  // Single Reference page
  singleReferents,
});

// Load Events
jQuery(document).on('ready', () => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js